module.exports = __webpack_public_path__ + "static/dealwatch2-35ce7d104b3e101af95b6dfdba84f7d9.png";